import { getCookie } from "@insite/client-framework/Common/Cookies";
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { emptyGuid } from "@insite/client-framework/Common/StringHelpers";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { Dictionary } from "@insite/client-framework/Common/Types";
import { setMainNavigation } from "@insite/client-framework/Components/ShellHoleConnect";
import Logger from "@insite/client-framework/Logger";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSession, getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import {
    getCategoriesDataView,
    getCategoryDepthLoaded,
    getCategoryState,
    getSubCategoryIds,
} from "@insite/client-framework/Store/Data/Categories/CategoriesSelectors";
import loadCategories from "@insite/client-framework/Store/Data/Categories/Handlers/LoadCategories";
import loadCategory from "@insite/client-framework/Store/Data/Categories/Handlers/LoadCategory";
import { getPageLinkByNodeId, getPageLinkByPageType } from "@insite/client-framework/Store/Links/LinksSelectors";
import translate from "@insite/client-framework/Translate";
import { HasFields } from "@insite/client-framework/Types/ContentItemModel";
import { LinkFieldValue } from "@insite/client-framework/Types/FieldDefinition";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { StylesContext } from "@insite/content-library/additionalStyles";
import { NavigationModeCookieName } from "@insite/content-library/Components/NavigationModeMenu";
import SearchInput, { SearchInputStyles } from "@insite/content-library/Widgets/Header/SearchInput";
import { ButtonPresentationProps } from "@insite/mobius/Button";
import { GridContainerProps } from "@insite/mobius/GridContainer";
import { GridItemProps } from "@insite/mobius/GridItem";
import Hidden from "@insite/mobius/Hidden";
import { IconProps } from "@insite/mobius/Icon";
import X from "@insite/mobius/Icons/X";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import { MenuPresentationProps } from "@insite/mobius/Menu";
import Modal, { ModalPresentationProps } from "@insite/mobius/Modal";
import { PopoverPresentationProps, PositionStyle } from "@insite/mobius/Popover";
import { TypographyPresentationProps } from "@insite/mobius/Typography";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import { resolveColor } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import surHeaderHeight from "@tSurya/Handlers/SurHeaderHeightHandler";
// eslint-disable-next-line spire/fenced-imports
import { TS } from "@insite/shell/TS";
import MainNavigationItem from "@tSurya/Overrides/Components/MainNavigationItem";
import NavigationDrawer from "@tSurya/Overrides/Components/NavigationDrawer";
import { COMMON, ELEMENTS, TYPOGRAPHY } from "@tSurya/theme/design";
import { isThemeActive, THEME_IDS } from "@tSurya/theme/themeHelper";
import * as cssLinter from "css";
import isEqual from "lodash/isEqual";
import * as React from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

const enum fields {
    links = "links",
    showQuickOrder = "showQuickOrder",
    customCSS = "customCSS",
    openParentPages = "openParentPages",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.links]: LinkModel[];
        [fields.showQuickOrder]: boolean;
        [fields.openParentPages]: boolean;
        [fields.customCSS]: string;
    };
    isCompactHeaderFlyoutMenu: boolean;
    flyoutCustomCSS?: string;
    showFlyoutPricingToggle?: boolean;
    showFlyoutInventoryToggle?: boolean;
    isCompactHeaderMainNavigation: boolean;
    сompactHeaderMainNavigationCustomCSS?: string;
    customMenuImage: string;
    customMenuImageLink: ImageInternalMenuLinks[];
}

interface LinkModel {
    fields: {
        openInNewWindow: boolean;
        disableNavigation?: boolean;
        destination: LinkFieldValue;
        linkType: "Link" | "MegaMenu" | "CascadingMenu" | "CustomLinkList";
        overrideTitle: string;
        title: string;
        numberOfColumns: number;
        // menuTitleisHighlighted: boolean;
        dropDownValue: string;
        maxDepth: number;
	childLinks?: LinkModel[];
        titleLink?: LinkFieldValue;
        parentTitle?: string;
        CustomMenu?: boolean;
        customMenuTitle: string;
        subMenuLinks: SubMenuLink[];
        isCustomMenu: boolean;
        customMenuImage: string;
        customMenuImageTittle: ImageInternalMenuLinks[];
    };
}

export interface SubMenuLink {
    fields: Fields;
    children?: MappedLink[];
}

export interface Fields {
    subMenuTitle: string;
    subDestination: Destination2;
    InternalMenuLinks: InternalMenuLinks[];
}

export interface Destination2 {
    type: string;
    value: string;
}

export interface InternalMenuLinks {
    fields: InternalFields;
}

export interface ImageInternalMenuLinks {
    fields: ImageInternalFields;
}

export interface InternalFields {
    internalMenuTitle: string;
    destination: Destination3;
    internalMenuTitleisBold: boolean;
    // internalMenuTitleisHighlighted: boolean;
    internaldropDownValue: string;
}
export interface ImageInternalFields {
    internalImgTitle: string;
    internalImgURL: string;
    internalImgTitledestination: string;
}
export interface Destination3 {
    type: string;
    value: string;
}

export interface MappedLink {
    title: string;
    url: string;
    image?: string;
    ImageTittle?: string;
    type?: string;
    disableNavigation?: boolean;
    excludeFromNavigation?: boolean;
    openInNewWindow?: boolean;
    // menuTitleisHighlighted?: boolean;
    dropDownValue?: string;
    numberOfColumns?: number;
    maxDepth?: number;
    childrenType?: "MegaMenu" | "CascadingMenu" | "CustomLinkList";
    children?: MappedLink[];
    CustomMenu?: boolean;
    customMenuTitle?: string;
    isCustomMenu?: boolean;
    subMenuLinks?: SubMenuLink[];
    customMenuImage?: string;
    isBold?: boolean;
    isHighlighted?: boolean;
    isDropDownValue?: string;
    customMenuImageTittle?: ImageInternalMenuLinks[];
}

// The mega menu renders section headings inline, but the mobile drawer needs them as their own second-level entries.
const promoteSectionHeadingsForDrawer = (links: MappedLink[]): MappedLink[] =>
    links.map(link => {
        if (!link.children?.length) {
            return link;
        }

        const promotedChildren: MappedLink[] = [];

        link.children.forEach(child => {
            const childLinks = child.children || [];
            const headingIndex = childLinks.findIndex(childLink => childLink.isDropDownValue === "sectionHeading");

            if (headingIndex < 0) {
                promotedChildren.push(child);
                return;
            }

            promotedChildren.push({ ...child, children: childLinks.slice(0, headingIndex) });

            let section: MappedLink | undefined;
            childLinks.slice(headingIndex).forEach(childLink => {
                if (childLink.isDropDownValue === "sectionHeading") {
                    section = { ...childLink, children: [] };
                    promotedChildren.push(section);
                    return;
                }

                section?.children?.push(childLink);
            });
        });

        return { ...link, children: promotedChildren };
    });

const mapStateToProps = (state: ApplicationState, ownProps: OwnProps) => {
    const {
        fields: { links = [] },
    } = ownProps;
    const mappedLinks = [];
    const categoryIdsToLoad: Dictionary<number> = {};

    for (const link of links) {
        const mappedLink = mapLink(link, state, categoryIdsToLoad);

        if (!mappedLink) {
            continue;
        }

        mappedLinks.push(mappedLink);
    }

    const currentMode = getCookie(NavigationModeCookieName) || "Storefront";
    const { orderSettings } = getSettingsCollection(state);
    const session = getSession(state);
    const isAuthenticated = session?.isAuthenticated && !session?.isGuest;
    const isVmiAdmin = session.userRoles?.toLowerCase().indexOf("vmi_admin") !== -1;
    const isVmiUser = session.userRoles?.toLowerCase().indexOf("vmi_user") !== -1;

    return {
        links: mappedLinks,
        quickOrderLink: getPageLinkByPageType(state, "QuickOrderPage"),
        categoryIdsToLoad,
        allowQuickOrder: orderSettings.allowQuickOrder,
        categoryErrorStatusCodeById: state.data.categories.errorStatusCodeById,
        categoryIdsCalled: state.data.categories.categoryIdsCalled,
        displayChangeCustomerLink: session?.displayChangeCustomerLink,
        displayVmiNavigation:
            currentMode === "Vmi" && orderSettings.vmiEnabled && isAuthenticated && (isVmiAdmin || isVmiUser),
        displayModeSwitch: isAuthenticated && orderSettings.vmiEnabled && (isVmiAdmin || isVmiUser),
        currentMode,
        vmiPageLinks: isVmiAdmin
            ? [
                  getPageLinkByPageType(state, "VmiDashboardPage"),
                  getPageLinkByPageType(state, "VmiLocationsPage"),
                  getPageLinkByPageType(state, "VmiUsersPage"),
                  getPageLinkByPageType(state, "VmiBinsPage"),
                  getPageLinkByPageType(state, "VmiReportingPage"),
                  getPageLinkByPageType(state, "VmiOrderHistoryPage"),
              ]
            : isVmiUser
            ? [
                  getPageLinkByPageType(state, "VmiDashboardPage"),
                  getPageLinkByPageType(state, "VmiLocationsPage"),
                  getPageLinkByPageType(state, "VmiBinsPage"),
                  getPageLinkByPageType(state, "VmiReportingPage"),
                  getPageLinkByPageType(state, "VmiOrderHistoryPage"),
              ]
            : [],
    };
};
const mapLink = (
    link: LinkModel,
    state: ApplicationState,
    categoryIdsToLoad: Dictionary<number>,
    isChildLink = false,
) => {
    const {
        fields: {
            linkType,
            destination,
            openInNewWindow,
            disableNavigation,
            overrideTitle: overrideTitleValue,
            numberOfColumns,
            maxDepth,
            title: titleValue,
            childLinks,
            parentTitle,
            titleLink,
            // Fields from old code
            dropDownValue,
            customMenuImage,
            customMenuImageTittle,
            customMenuTitle,
            isCustomMenu,
            subMenuLinks,
        },
    } = link;
    
    const { type: typeValue, value: destinationValue } = destination;
    let type = typeValue;
    let value = destinationValue;
    let title = titleValue;
    let overrideTitle = overrideTitleValue;
    
    // Handle CustomLinkList type
    if (linkType === "CustomLinkList") {
        type = titleLink?.type ?? "Page";
        value = titleLink?.value ?? "";
        title = parentTitle ?? "";
        overrideTitle = parentTitle ?? "";
    }
    
    const depthToLoad = linkType === "MegaMenu" ? 3 : linkType === "CustomLinkList" || isChildLink ? 0 : maxDepth;
    let mappedLink: MappedLink | undefined;
    
    // Map based on destination type
    if (type === "Url") {
        mappedLink = {
            url: value,
            title: isChildLink ? overrideTitle : title,
        };
    } else if (type === "Page") {
        const readonlyPageLink = getPageLinkByNodeId(state, value);
        if (readonlyPageLink) {
            mappedLink = { ...readonlyPageLink };
            if (overrideTitle) {
                mappedLink.title = overrideTitle;
            }
        }
    } else if (type === "Category") {
        mappedLink = setupCategoryLink(
            state,
            value,
            categoryIdsToLoad,
            depthToLoad,
            overrideTitle,
            state.data.categories.categoryIdsCalled,
        );
    }
    
    // Handle CustomLinkList children (new code logic)
    if (linkType === "CustomLinkList") {
        if (!mappedLink) {
            mappedLink = {
                title: parentTitle ?? title,
                url: "",
                excludeFromNavigation: false,
                childrenType: "CustomLinkList",
            };
        }
        let mappedChildren: MappedLink[] = [];
        if (childLinks && childLinks.length > 0) {
            for (const child of childLinks) {
                const childLink = mapLink(child, state, categoryIdsToLoad, true);
                if (childLink) {
                    mappedChildren.push(childLink);
                }
            }
        }
        mappedLink.children = mappedChildren;
    }
    
    // Handle MegaMenu with custom menu (old code logic)
    if (linkType === "MegaMenu" && isCustomMenu && subMenuLinks) {
        const subMenuMappedLinks: MappedLink[] = [];
        
        for (const subMenu of subMenuLinks) {
            let subMenuMappedLink;
            const internalSubMenuMappedLinks: MappedLink[] = [];
            
            const { type: subType, value: subValue } = subMenu.fields.subDestination;
            
            // Map submenu destination
            if (subType === "Url") {
                subMenuMappedLink = {
                    url: subValue,
                    title: subMenu.fields.subMenuTitle,
                };
            } else if (subType === "Category") {
                subMenuMappedLink = setupCategoryLink(
                    state,
                    subValue,
                    categoryIdsToLoad,
                    depthToLoad,
                    subMenu.fields.subMenuTitle,
                    state.data.categories.categoryIdsCalled,
                );
            } else if (subType === "Page") {
                const readonlyPageLink = getPageLinkByNodeId(state, subValue);
                if (readonlyPageLink) {
                    subMenuMappedLink = { ...readonlyPageLink };
                    if (subMenu.fields.subMenuTitle) {
                        subMenuMappedLink.title = subMenu.fields.subMenuTitle;
                    }
                }
            }
            
            // Map internal menu links
            if (subMenu.fields?.InternalMenuLinks) {
                for (const internalLink of subMenu.fields.InternalMenuLinks) {
                    let internalMenuMapLink: any | undefined = [];
                    const { type: intType, value: intValue } = internalLink.fields.destination;
                    
                    if (intType === "Url") {
                        internalMenuMapLink = {
                            url: intValue,
                            title: internalLink.fields.internalMenuTitle,
                        };
                    } else if (intType === "Page") {
                        const readonlyPageLink = getPageLinkByNodeId(state, intValue);
                        if (readonlyPageLink) {
                            internalMenuMapLink = { ...readonlyPageLink };
                            if (internalLink.fields.internalMenuTitle) {
                                internalMenuMapLink.title = internalLink.fields.internalMenuTitle;
                            }
                        }
                    } else if (intType === "Category") {
                        internalMenuMapLink = setupCategoryLink(
                            state,
                            intValue,
                            categoryIdsToLoad,
                            depthToLoad,
                            internalLink.fields.internalMenuTitle,
                            state.data.categories.categoryIdsCalled,
                        );
                    }
                    
                    if (internalMenuMapLink) {
                        internalMenuMapLink.isBold = internalLink.fields.internalMenuTitleisBold;
                        internalMenuMapLink.isDropDownValue = internalLink.fields.internaldropDownValue;
                        internalSubMenuMappedLinks.push(internalMenuMapLink);
                    }
                }
            }
            
            // Merge internal links with submenu children
            if (subMenuMappedLink) {
                if (internalSubMenuMappedLinks.length > 0) {
                    subMenuMappedLink.children = subMenuMappedLink.children
                        ? [...subMenuMappedLink.children, ...internalSubMenuMappedLinks]
                        : internalSubMenuMappedLinks;
                }
                subMenuMappedLinks.push(subMenuMappedLink);
            }
        }
        
        if (mappedLink && subMenuMappedLinks.length > 0) {
            mappedLink.children = subMenuMappedLinks;
        }
    }
    
    if (!mappedLink) {
        return;
    }
    
    // Set common properties
    mappedLink.openInNewWindow = openInNewWindow;
    mappedLink.disableNavigation = disableNavigation;
    mappedLink.numberOfColumns = numberOfColumns;
    mappedLink.maxDepth = maxDepth;
    mappedLink.dropDownValue = dropDownValue;
    mappedLink.customMenuImage = customMenuImage;
    mappedLink.customMenuImageTittle = customMenuImageTittle;
    mappedLink.customMenuTitle = customMenuTitle;
    mappedLink.excludeFromNavigation =
        linkType === "CustomLinkList" || isChildLink ? false : mappedLink.excludeFromNavigation;
    
    if (linkType === "MegaMenu" || linkType === "CascadingMenu" || linkType === "CustomLinkList") {
        mappedLink.childrenType = linkType;
    }
    
    return mappedLink;
};

const getParameter = (categoryId: string, maxDepth: number) => ({
    maxDepth,
    startCategoryId: categoryId === emptyGuid ? undefined : categoryId,
    includeStartCategory: categoryId !== emptyGuid,
});

const setupCategoryLink = (
    state: ApplicationState,
    value: string,
    categoryIdsToLoad: Dictionary<number>,
    maxDepth: number,
    overrideTitle: string,
    categoryIdsCalled: string[],
) => {
    let mappedLink: MappedLink | undefined;

    if (!value) {
        return;
    }

    const depthLoaded = getCategoryDepthLoaded(state, value);
    const subCategoryIds = getSubCategoryIds(state, value);
    if (
        (depthLoaded < maxDepth || (!subCategoryIds && !categoryIdsCalled?.includes(value))) &&
        !getCategoriesDataView(state, getParameter(value, maxDepth)).isLoading
    ) {
        categoryIdsToLoad[value] = maxDepth;
    } else {
        if (value === emptyGuid) {
            mappedLink = {
                url: "",
                title: overrideTitle || translate("Products"),
            };
        } else {
            const categoryState = getCategoryState(state, value);
            if (!categoryState.value) {
                if (
                    !categoryState.isLoading &&
                    !getCategoriesDataView(state, getParameter(value, maxDepth)).isLoading
                ) {
                    categoryIdsToLoad[value] = maxDepth;
                }
                return;
            }
            mappedLink = {
                url: categoryState.value.path,
                title: overrideTitle || categoryState.value.shortDescription,
            };
        }

        loadSubCategories(mappedLink, subCategoryIds, 1, maxDepth, state);
    }

    return mappedLink;
};

const loadSubCategories = (
    mappedLink: MappedLink,
    subCategoryIds: readonly string[] | undefined,
    currentDepth: number,
    maxDepth: number,
    state: ApplicationState,
) => {
    if (currentDepth > maxDepth) {
        return;
    }
    mappedLink.children = [];
    if (!subCategoryIds) {
        return;
    }
    for (const subCategoryId of subCategoryIds) {
        const subCategory = getCategoryState(state, subCategoryId).value;
        if (!subCategory) {
            Logger.error(`Category ${subCategoryId} was not found in data state, excluding from navigation.`);
            continue;
        }
        const childLink: MappedLink = {
            url: subCategory.path,
            title: subCategory.shortDescription,
            children: [],
        };
        mappedLink.children.push(childLink);

        loadSubCategories(childLink, subCategory.subCategoryIds, currentDepth + 1, maxDepth, state);
    }
};

const mapDispatchToProps = {
    loadCategories,
    surHeaderHeight,
};

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

interface State {
    selectedLinkIndex?: number;
    mobileSearchModalIsOpen: boolean;
    customImage: any;
}

export interface MainNavigationStyles {
    menuHeight: number;
    container?: InjectableCss;
    itemWrapper?: InjectableCss;
    navigationPopup?: InjectableCss;
    quickOrderItemWrapper?: InjectableCss;
    menuItem?: InjectableCss;
    menuItemIcon?: IconProps;
    openMegaMenu?: InjectableCss;
    openCustomMegaMenu?: InjectableCss;
    closeMegaMenu?: InjectableCss;
    menuItemTypography?: TypographyPresentationProps;
    cascadingMenu?: MenuPresentationProps;
    megaMenu?: PopoverPresentationProps;
    megaMenuGridContainer?: GridContainerProps;
    megaMenuGridItem?: GridItemProps;
    megaMenuGridItemImg?: GridItemProps;
    imageMenuGridItem?: GridItemProps;
    megaMenuHeading?: LinkPresentationProps;
    megaMenuSpanHeading?: TypographyPresentationProps;
    megaMenuLink?: LinkPresentationProps;
    mobileWrapper?: InjectableCss;
    compactFlyoutMenu?: InjectableCss;
    mobileMenuWrapper?: InjectableCss;
    mobileSearchButton?: ButtonPresentationProps;
    mobileSearchWrapper?: InjectableCss;
    mobileSearchModal?: ModalPresentationProps;
    mobileSearchInputWrapper?: InjectableCss;
    mobileSearchInputStyles?: SearchInputStyles;
    mobileSearchModalCloseIcon?: IconProps;
    menuitemImage?: InjectableCss;
    menuList?: InjectableCss;
}

export const mainNavigationStyles: MainNavigationStyles = {
    menuHeight: 50,
    container: {
        css: css`
            color: ${getColor("common.background")};
            display: flex;
            justify-content: ${isThemeActive(THEME_IDS.MGBW) ? 'center' : 'space-between'};
            align-items: center;
            flex-wrap: wrap;
            column-gap: ${isThemeActive(THEME_IDS.MGBW) ? '80px' : '10px'};
            ${isThemeActive(THEME_IDS.MGBW) ? `padding: 0 60px;` : ''}
            /* padding: 0 15px; */
            @media only screen and (max-width: 1280px) {
                ${isThemeActive(THEME_IDS.MGBW) ? '' : `column-gap: 12px;`}

                ::after {
                    /* content: ""; */
                    flex: auto;
                }
            }
            @media only screen and (max-width: 1045px) {
                .item-wrapper:last-child {
                    margin-left: ${isThemeActive(THEME_IDS.MGBW) ? '0' : '12px'};
                }
            }

            @media only screen and (max-width: 1166px) {
                display: none !important;
            }
            .cascadingOpen + ul {
                display: none !important;
            }

            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        null,
                        css`
                            padding: 0 16px;
                        `,
                        null,
                    ],
                    "max",
                );
            }}
        `,
    },
    itemWrapper: {
        css: css`
            overflow: visible;
            display: flex;
            /* &:hover span + div {
                display: block;
            }
            &:hover div {
                display: block;
            } */
            &:first-child {
                /* margin-left: -10px; */
            }
            &:last-child {
                a {
                    padding-right: 0px;
                }
            }
        `,
    },
    openMegaMenu: {
        css: css`
            display: block;
            background: #fff;
            position: absolute;
            min-height: 120px;
            width: 100%;
            border: 1px solid #ebedeb;
            overflow-y: auto;
            max-height: calc(100vh - 140px);
            padding: 70px;
            left: 0;
            z-index: 2070;
            left: 50% !important;
            transform: translateX(-50%);
            box-shadow: ${ELEMENTS.megamenu.boxShadow};
            > div {
                max-width: 1240px;
                margin: 0 auto;
                ${({ theme }) => {
                    return breakpointMediaQueries(
                        theme,
                        [
                            null,
                            null,
                            null,
                            css`
                                max-width: 1140px;
                            `,
                            null,
                        ],
                        "max",
                    );
                }}
            }
        `,
    },
    closeMegaMenu: {
        css: css`
            display: none;
            background: #f8f9fa;
            position: absolute;
            top: 122px;
            left: 0;
            z-index: 2070;
            width: 100%;
            box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.3);
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        null,
                        css`
                            top: 105px;
                        `,
                        null,
                    ],
                    "max",
                );
            }}
            div[class^="GridWrapper"] {
                margin: 0 auto;
                padding: 10px 35px 25px;
                ul {
                    li {
                        // padding: 30px 5px 10px 5px;

                        a {
                            margin-bottom: 0;
                            text-transform: ${TYPOGRAPHY.header.textTransform};
                            font-size: ${TYPOGRAPHY.megaMenuLink.size};
                            ${({ theme }) => {
                                return breakpointMediaQueries(
                                    theme,
                                    [
                                        null,
                                        null,
                                        null,
                                        css`
                                            padding-bottom: 10px;
                                        `,
                                    ],
                                    "minMax",
                                );
                            }}
                        }
                        ul {
                            //  column-count: unset;
                            display: block;
                            li {
                                padding: 0;
                                border-bottom: none;
                                a span {
                                    color: #333;
                                    font-size: ${TYPOGRAPHY.megaMenuLink.size};
                                    padding: 4px 10px 4px 0px;
                                    line-height: initial;
                                    text-transform: ${TYPOGRAPHY.header.textTransform};
                                }
                            }
                        }
                    }
                }
            }
        `,
    },
    navigationPopup: {
        css: css`
            width: 100%;
            min-height: 150px;
            display: none;
            position: absolute;
            top: 50px;
            left: 0;
        `,
    },
    quickOrderItemWrapper: {
        css: css`
            margin-left: auto;
            margin-right: 0;
        `,
    },
    megaMenuGridItem: {
        css: css`
            display: block;
        `,
    },
    megaMenuGridItemImg: {
        width: 3,
        css: css`
            padding: 0px;
            gap: 20px;
        `,
    },
    imageMenuGridItem: {
        css: css`
            display: block;
            max-width: 60%;
            display: flex;
            align-items: center;
            justify-content: center;
            img {
                aspect-ratio: 1/1;
                width: 100%;
                height: auto;
                max-width: 350px;
            }
        `,
    },
    megaMenuHeading: {
        css: css`
            span {
                font-family: ${TYPOGRAPHY.fontFamily.title};
                font-style: normal;
                font-weight: ${TYPOGRAPHY.megaMenuHeading.weight};
                font-size: ${TYPOGRAPHY.megaMenuHeading.size};
                line-height: ${TYPOGRAPHY.megaMenuHeading.lineHeight};
                letter-spacing: ${TYPOGRAPHY.megaMenuHeading.letterSpacing};
                text-transform: ${TYPOGRAPHY.megaMenuHeading.textTransform};
                color: ${TYPOGRAPHY.megaMenuHeading.color} !important;
            }
        `,
    },
    megaMenuSpanHeading: {
        css: css`
            font-family: ${TYPOGRAPHY.fontFamily.title};
            font-style: normal;
            font-weight: ${TYPOGRAPHY.megaMenuHeading.weight};
            font-size: ${TYPOGRAPHY.megaMenuHeading.size};
            line-height: ${TYPOGRAPHY.megaMenuHeading.lineHeight};
            letter-spacing: ${TYPOGRAPHY.megaMenuHeading.letterSpacing};
            text-transform: ${TYPOGRAPHY.megaMenuHeading.textTransform};
            display: block;
            color: ${TYPOGRAPHY.megaMenuHeading.color} !important;
        `,
    },
    menuItem: {
        css: css`
            display: flex;
            align-items: center;
            padding: ${ELEMENTS.navigationItemDesktop.padding};
            position: relative;

            &:first-child {
                padding-left: 0;
                padding-right: 0;
            }

            &:last-child {
                padding-right: 0;
                padding-right: 0;
            }
            &.topSeller {
                span {
                    color: ${getColor("success")}!important;
                }
            }
            &.new {
                span {
                    color: ${getColor("warning")} !important;
                }
            }
            &.clearance {
                span {
                    color: ${getColor("danger")} !important;
                }
            }

            span {
                color: ${getColor("text.main")} !important;
                font-style: normal;
                font-weight: ${TYPOGRAPHY.header.weight};
                font-size: ${TYPOGRAPHY.header.size};
                line-height: ${TYPOGRAPHY.header.lineHeight};
                letter-spacing: ${TYPOGRAPHY.header.letterSpacing};
                text-transform: ${TYPOGRAPHY.header.textTransform};
                display: block;

                ${isThemeActive(THEME_IDS.MGBW) ? `
                    text-transform: uppercase;
                    letter-spacing: 1.6px;
                ` : ''}

                &:hover {
                    &::after {
                        content: "";
                        z-index: 3000;
                        border-bottom: 2px solid ${getColor("text.main")};
                        width: 100%;
                        position: absolute;
                        bottom: 0;
                        left: 0;
                    }
                }
            }

            &.makeItYours {
                span {
                    font-family: ${TYPOGRAPHY.fontFamily.heading};
                    font-style: italic;
                    font-size: 20px;
                    text-transform: none;
                    letter-spacing: 1.6px;
                }
            }
        `,
    },
    menuItemIcon: {
        css: css`
            margin: -3px 0 0 10px;
        `,
        size: 18,
        color: "secondary.contrast",
    },
    menuItemTypography: {
        variant: "headerSecondary",
        color: "secondary.contrast",
        css: css`
            font-weight: 800;
        `,
    },
    megaMenu: {
        transitionDuration: "short",
        contentBodyProps: {
            _height: "1200px",
            css: css`
                padding: ${ELEMENTS.megamenu.padding};
                border-top: 1px solid #E8E8E8;
                ${isThemeActive(THEME_IDS.MGBW) ? `
                box-shadow: 0 100vh 0 100vh rgba(0, 0, 0, 0.20);
                ` : ''}
                > div {
                    > ul > div[class^="GridItemStyle"] {
                        padding: 0 !important;
                        gap: 20px;
                        > li {
                            padding: 0px !important;
                        }
                        > li:first-of-type {
                            > span:first-of-type {
                                font-size: ${TYPOGRAPHY.megaMenuLink.size};
                            }
                        }
                        &:last-of-type {
                            > div > a {
                                min-width: 100% !important;
                            }
                        }
                    }
                }
            `,
        },
    },
    mobileSearchButton: {
        size: 48,
        buttonType: "solid",
        color: "secondary",
        css: css`
            padding: 0 10px;
        `,
    },
    compactFlyoutMenu: {
        css: css`
            & button {
                background: transparent;
                border: none;
                &:hover {
                    background: rgba(0, 0, 0, 0.3);
                }

                svg {
                    color: ${props => resolveColor(props.theme.header.linkColor, props.theme)};
                }
            }
        `,
    },
    mobileSearchWrapper: {
        css: css`
            text-align: right;
            width: 100%;
        `,
    },
    mobileMenuWrapper: {
        css: css`
            text-align: right;
            @media only screen and (max-width: 1166px) {
                display: block !important;
            }
        `,
    },
    mobileSearchInputWrapper: {
        css: css`
            display: flex;
            align-items: center;
        `,
    },
    mobileSearchInputStyles: {
        input: {
            cssOverrides: {
                formField: css`
                    width: 100%;
                `,
            },
        },
        popover: {
            wrapperProps: {
                css: css`
                    width: calc(100% - 45px);
                `,
            },
        },
        popoverContentBody: {
            as: "div",
            _height: "100%",
            css: css`
                box-shadow: none;
            `,
        },
        autocompleteWrapper: {
            css: css`
                display: flex;
                flex-direction: column;
            `,
        },
        autocompleteColumnWrapper: {
            css: css`
                display: flex;
                flex-direction: column;
                width: 100%;
                padding: 0 50px 0 30px;
            `,
        },
        searchHistoryStyles: {
            wrapper: {
                css: css`
                    display: flex;
                    flex-direction: column;
                    width: 100%;
                    padding: 0 50px 15px 30px;
                `,
            },
        },
        autocompleteProductsStyles: {
            titleLink: {
                css: css`
                    width: 100%;
                `,
            },
            erpNumberText: {
                css: css`
                    width: 100%;
                    text-align: left;
                    margin: 5px 0 0 0;
                `,
            },
        },
    },
    mobileSearchModalCloseIcon: {
        src: X,
        size: 18,
        css: css`
            margin-left: 10px;
        `,
    },
    megaMenuGridContainer: {
        css: css`
            max-width: ${COMMON.width.content}px !important;
            margin: 0 auto;
            padding: 0 ${ELEMENTS.megamenu.gridPadding};

            
            /* padding: 0 15px; */
            ul {
                margin: 0px;
                width: 100%;
            }
            > ul {
                display: flex;
                flex-wrap: nowrap !important;
                column-gap: ${ELEMENTS.megamenu.columnGap};
                justify-content: ${ELEMENTS.megamenu.justifyContent};
                width: 100% !important;
                > li {
                    padding: 0px;
                }
            }
        `,
    },
    menuitemImage: {
        css: css`
            column-gap: 20px;
            display: flex;
            img {
                aspect-ratio: 1/1;
                width: 100%;
                height: auto;
                max-width: 350px;
            }
        `,
    },
    megaMenuLink: {
        css: css`
            &.megaMenuLinkBold {
                span {
                    font-weight: 700;
                }
            }
            &.sectionHeading {
                padding-top: 24px;
                margin: 0;
                font-family: ${TYPOGRAPHY.fontFamily.title};
                font-size: ${TYPOGRAPHY.megaMenuHeading.size};
                font-style: normal;
                font-weight: ${TYPOGRAPHY.megaMenuHeading.weight};
                line-height: ${TYPOGRAPHY.megaMenuHeading.lineHeight};
                letter-spacing: ${TYPOGRAPHY.megaMenuHeading.letterSpacing};
                text-transform: ${TYPOGRAPHY.megaMenuHeading.textTransform};
                color: ${TYPOGRAPHY.megaMenuHeading.color} !important;
                display: block;
                span {
                    font-family: ${TYPOGRAPHY.fontFamily.title};
                    font-size: ${TYPOGRAPHY.megaMenuHeading.size};
                    font-style: normal;
                    font-weight: ${TYPOGRAPHY.megaMenuHeading.weight};
                    line-height: ${TYPOGRAPHY.megaMenuHeading.lineHeight};
                    letter-spacing: ${TYPOGRAPHY.megaMenuHeading.letterSpacing};
                    text-transform: ${TYPOGRAPHY.megaMenuHeading.textTransform};
                    color: ${TYPOGRAPHY.megaMenuHeading.color} !important;
                    margin-bottom: 0;
                }
            }
            &.topSeller {
                span {
                    color: ${getColor("success")}!important;
                }
            }
            &.new {
                span {
                    color: ${getColor("warning")} !important;
                }
            }
            &.clearance {
                span {
                    color: ${getColor("danger")} !important;
                }
            }
            span {
                font-family: ${TYPOGRAPHY.fontFamily.title};
                font-style: normal;
                font-weight: ${TYPOGRAPHY.megaMenuLink.weight};
                font-size: ${TYPOGRAPHY.megaMenuLink.size};
                line-height: ${TYPOGRAPHY.megaMenuLink.lineHeight};
                letter-spacing: ${TYPOGRAPHY.megaMenuLink.letterSpacing};
                color: ${TYPOGRAPHY.megaMenuLink.color} !important;
                display: block;
                margin-top: ${ELEMENTS.menuItem.marginTop};
            }
        `,
    },
    menuList: {
        css: css`
            margin: 0px !important;
        `,
    },
};

const defaultCustomCss = `.mobile-wrapper {
}

.mobile-menu-wrapper {
}

.menu-trigger-button {
}

.menu-trigger-button-icon {
}

.drawer {
}

.drawer-section-wrapper {
}
.currency-selector-wrapper {
}

.language-selector-wrapper {
}

.panel-menu {
}

.main-navigation-row {
}

.panel-section-wrapper {
}

.main-navigation-row-icon {
}

.user-row-text {
}

.punch-out-navigation-row-icon {
}

.punch-out-user-row-text {
}

.main-navigation-row-text {
}

.logo-links-row {
}

.logo-link-title {
}

.language-image {
}

.menu-row-icon {
}

.change-customer-row {
}

.change-customer-row-container {
}

.fulfillment-method-grid-item {
}

.addresses-grid-item {
}

.pick-up-address-grid-item {
}

.apply-button-grid-item {
}

.sign-out-row {
}

.sign-out-row-text {
}

.mobile-search-wrapper {
}

.mobile-search-button {
}

.mobile-search-button-icon {
}

.container {
}

.item-wrapper {
}

.cascading-menu {
}

.menu-item {
}

.mega-menu {
}

.mega-menu-grid-container {
}

.mega-menu-grid-item {
}

.mega-menu-heading-link {
}

.mega-menu-link {
}

.quick-order-item-wrapper {
}

.quick-order-link {
}

.vmi-page-link {
}

.mobile-search-modal {
}`;

export class MainNavigation extends React.Component<Props, State> {
    container = React.createRef<HTMLDivElement | null>();
    mobileSearchInput = React.createRef<HTMLInputElement>();
    declare context: React.ContextType<typeof StylesContext>;

    private loadCategoriesTimeout?: ReturnType<typeof setTimeout>;
    private headerResizeObserver?: ResizeObserver;
    private headerMeasurementFrame?: number;
    private menuBar?: HTMLElement;
    private measuredHeaderHeight?: number;

    private measureHeaderHeight = () => {
        const menuBar: HTMLElement | null = document.querySelector("#MenuBAr");
        const headerHeight = menuBar
            ? menuBar.offsetHeight
            : (document.querySelector<HTMLElement>("#headerHeightRef")?.offsetHeight ?? 0) +
              (document.querySelector<HTMLElement>("#secondaryNavRef")?.offsetHeight ?? 0);

        if (headerHeight === this.measuredHeaderHeight) {
            return;
        }

        this.measuredHeaderHeight = headerHeight;
        this.props.surHeaderHeight({ headerHeight });
    };

    private scheduleHeaderHeightMeasurement = () => {
        if (this.headerMeasurementFrame !== undefined) {
            window.cancelAnimationFrame(this.headerMeasurementFrame);
        }
        this.headerMeasurementFrame = window.requestAnimationFrame(() => {
            this.headerMeasurementFrame = undefined;
            this.measureHeaderHeight();
        });
    };

    constructor(props: Props) {
        super(props);

        this.state = {
            mobileSearchModalIsOpen: false,
            customImage: "",
        };
    }

    UNSAFE_componentWillMount(): void {
        this.scheduleLoadCategoriesIfNeeded();

        setMainNavigation({
            close: () => {
                this.setState({
                    selectedLinkIndex: undefined,
                });
            },
            openMenu: (index: number) => {
                this.setState({
                    selectedLinkIndex: index,
                });
            },
        });
    }

    componentDidMount(): void {
        const menuBar = document.querySelector<HTMLElement>("#MenuBAr");
        const header = document.querySelector<HTMLElement>("#headerHeightRef");
        const secondaryNav = document.querySelector<HTMLElement>("#secondaryNavRef");

        this.menuBar = menuBar ?? undefined;
        if (typeof ResizeObserver !== "undefined") {
            this.headerResizeObserver = new ResizeObserver(this.scheduleHeaderHeightMeasurement);
            [menuBar, header, secondaryNav].forEach(element => {
                if (element) {
                    this.headerResizeObserver?.observe(element);
                }
            });
        }

        menuBar?.addEventListener("load", this.scheduleHeaderHeightMeasurement, true);
        window.addEventListener("resize", this.scheduleHeaderHeightMeasurement);
        window.addEventListener("orientationchange", this.scheduleHeaderHeightMeasurement);
        this.measureHeaderHeight();
    }

    componentWillUnmount(): void {
        if (this.headerMeasurementFrame !== undefined) {
            window.cancelAnimationFrame(this.headerMeasurementFrame);
            this.headerMeasurementFrame = undefined;
        }
        this.headerResizeObserver?.disconnect();
        this.menuBar?.removeEventListener("load", this.scheduleHeaderHeightMeasurement, true);
        window.removeEventListener("resize", this.scheduleHeaderHeightMeasurement);
        window.removeEventListener("orientationchange", this.scheduleHeaderHeightMeasurement);
        if (this.loadCategoriesTimeout) {
            clearTimeout(this.loadCategoriesTimeout);
            this.loadCategoriesTimeout = undefined;
        }
    }

    componentDidUpdate(prevProps: Readonly<Props>): void {
        if (!isEqual(this.props.categoryIdsToLoad, prevProps.categoryIdsToLoad)) {
            this.scheduleLoadCategoriesIfNeeded(true);
        }
    }

    private scheduleLoadCategoriesIfNeeded(isComponentDidUpdate = false) {
        if (IS_SERVER_SIDE) {
            this.loadCategoriesIfNeeded(isComponentDidUpdate);
            return;
        }

        if (this.loadCategoriesTimeout) {
            clearTimeout(this.loadCategoriesTimeout);
        }

        this.loadCategoriesTimeout = setTimeout(() => {
            this.loadCategoriesIfNeeded(isComponentDidUpdate);
        }, 0);
    }

    loadCategoriesIfNeeded(isComponentDidUpdate = false) {
        const { categoryIdsToLoad } = this.props;
        const pending: Array<{ categoryId: string; maxDepth: number }> = [];
        for (const categoryId of Object.keys(categoryIdsToLoad)) {
            if (!this.props.categoryErrorStatusCodeById?.[categoryId]) {
                const maxDepth = categoryIdsToLoad[categoryId];
                if (!this.props.categoryIdsCalled?.includes(categoryId) || isComponentDidUpdate) {
                    pending.push({ categoryId, maxDepth });
                }
            }
        }

        if (IS_SERVER_SIDE) {
            pending.forEach(({ categoryId, maxDepth }) =>
                this.props.loadCategories(getParameter(categoryId, maxDepth)),
            );
            return;
        }

        // Spread category loads across ticks to avoid React's nested update limit.
        const dispatchNext = (index: number) => {
            if (index >= pending.length) {
                return;
            }
            const { categoryId, maxDepth } = pending[index];
            this.props.loadCategories(getParameter(categoryId, maxDepth));
            this.loadCategoriesTimeout = setTimeout(() => dispatchNext(index + 1), 0);
        };
        dispatchNext(0);
    }

    getMobileSearchAutocompletePosition = (element: React.RefObject<HTMLUListElement | null>) => {
        const positionStyle: PositionStyle = {
            position: "fixed",
        };

        if (element.current) {
            const rect = element.current.getBoundingClientRect();
            positionStyle.top = rect.top + rect.height;
            positionStyle.left = 0;
            positionStyle.width = `${document.documentElement.clientWidth}px`;
            positionStyle.height = `${document.documentElement.clientHeight - positionStyle.top}px`;
        }

        return positionStyle;
    };

    mobileSearchButtonClickHandler = () => {
        this.setState({ mobileSearchModalIsOpen: true }, () => {
            setTimeout(() => {
                if (this.mobileSearchInput?.current) {
                    this.mobileSearchInput.current.focus();
                    this.mobileSearchInput.current.click();
                }
            }, 250);
        });
    };

    mobileSearchModalCloseHandler = () => {
        this.setState({ mobileSearchModalIsOpen: false });
    };

    render() {
        const {
            links,
            quickOrderLink,
            fields: { showQuickOrder, openParentPages, customCSS },
            id,
            allowQuickOrder,
            isCompactHeaderFlyoutMenu,
            flyoutCustomCSS,
            showFlyoutPricingToggle,
            showFlyoutInventoryToggle,
            isCompactHeaderMainNavigation,
            сompactHeaderMainNavigationCustomCSS,
            vmiPageLinks,
            displayVmiNavigation,
            displayModeSwitch,
            currentMode,
            // customMenuImage,
        } = this.props;
        const { selectedLinkIndex } = this.state;

        const showQuickOrderLink = showQuickOrder && allowQuickOrder;
        const mainNavContextStyles = this?.context?.styles?.mainNavigation ?? {};
        const styles = mergeToNew(mainNavigationStyles, mainNavContextStyles);
        const drawerLinks = isThemeActive(THEME_IDS.MGBW) ? promoteSectionHeadingsForDrawer(links) : links;

        if (isCompactHeaderFlyoutMenu) {
            const flyoutCustomCssWrapper = {
                css: css`
                    ${flyoutCustomCSS}
                `,
            };

            return (
                <StyledWrapper {...flyoutCustomCssWrapper}>
                    <StyledWrapper className="flyout-menu-wrapper" {...styles.compactFlyoutMenu}>
                        <NavigationDrawer
                            links={drawerLinks}
                            showQuickOrder={showQuickOrderLink}
                            quickOrderLink={quickOrderLink}
                            displayVmiNavigation={displayVmiNavigation}
                            vmiPageLinks={vmiPageLinks}
                            displayModeSwitch={displayModeSwitch}
                            currentMode={currentMode}
                            id={id}
                            isCompactHeaderFlyout={true}
                            showFlyoutPricingToggle={showFlyoutPricingToggle}
                            showFlyoutInventoryToggle={showFlyoutInventoryToggle}
                            rootElementSelector=".mobile-menu-wrapper"
                            allowOpenParentLinks={openParentPages}
                        />
                    </StyledWrapper>
                </StyledWrapper>
            );
        }
        if (isCompactHeaderMainNavigation) {
            const mainNavigationCustomCSSWrapper = {
                css: css`
                    ${сompactHeaderMainNavigationCustomCSS}
                `,
            };

            return (
                <StyledWrapper {...mainNavigationCustomCSSWrapper}>
                    <StyledWrapper className="container" {...styles.container} ref={this.container}>
                        {links.map((link, index) => {
                            return (
                                 
                                <StyledWrapper
                                        className="item-wrapper"
                                        {...styles.itemWrapper}
                                        key={index}
                                        data-test-selector={`mainNavigationLink-${link.title.replace(/\s+/g, "")}`}
                                    >
                                    <MainNavigationItem
                                        id={id}
                                        index={index}
                                        link={link}
                                        styles={styles}
                                        container={this.container}
                                        isOpen={index === selectedLinkIndex}
                                        displayChangeCustomerLink={this.props.displayChangeCustomerLink}
                                       // hover={false}
                                        // menuItemImage={this.state.customImage}
                                    />
                                </StyledWrapper>
                            );
                        })}
                        {showQuickOrderLink && quickOrderLink && (
                            <StyledWrapper className="item-wrapper" {...styles.itemWrapper}>
                                <StyledWrapper className="quick-order-item-wrapper" {...styles.quickOrderItemWrapper}>
                                    <Link
                                        className="quick-order-link"
                                        typographyProps={styles.menuItemTypography}
                                        color={styles.menuItemTypography?.color}
                                        {...styles.menuItem}
                                        id="quickOrder"
                                        href={quickOrderLink.url}
                                    >
                                        {quickOrderLink.title}
                                    </Link>
                                </StyledWrapper>
                            </StyledWrapper>
                        )}
                    </StyledWrapper>
                </StyledWrapper>
            );
        }

        const customCssWrapper = {
            css: css`
                ${customCSS}
            `,
        };

        return (
            <StyledWrapper {...customCssWrapper}>
                <StyledWrapper className="mobile-wrapper" {...styles.mobileWrapper}>
                    <Hidden className="mobile-menu-wrapper" above="md" {...styles.mobileMenuWrapper}>
                        <NavigationDrawer
                            links={drawerLinks}
                            showQuickOrder={showQuickOrderLink}
                            quickOrderLink={quickOrderLink}
                            displayVmiNavigation={displayVmiNavigation}
                            vmiPageLinks={vmiPageLinks}
                            id={id}
                            displayModeSwitch={displayModeSwitch}
                            currentMode={currentMode}
                            allowOpenParentLinks={openParentPages}
                        />
                    </Hidden>
                    {/* <Hidden className="mobile-search-wrapper" above="sm" {...styles.mobileSearchWrapper}>
                        <Button
                            className="mobile-search-button"
                            {...styles.mobileSearchButton}
                            onClick={this.mobileSearchButtonClickHandler}
                        >
                            <ButtonIcon className="mobile-search-button-icon" src={Search} />
                            <VisuallyHidden>{translate("Search")}</VisuallyHidden>
                        </Button>
                    </Hidden> */}
                </StyledWrapper>
                <StyledWrapper>
                    <Hidden
                        below="lg"
                        css={css`
                            @media (min-width: 992px) and (max-width: 1166px) {
                                display: block !important;
                            }
                        `}
                    >
                        {!displayVmiNavigation && (
                            <StyledWrapper className="container" {...styles.container} ref={this.container} data-test-selector="mainNavigationLinks">
                                {links.map((link, index) => {
                                    return (
                                        <StyledWrapper
                                            className="item-wrapper"
                                            {...styles.itemWrapper}
                                            data-test-selector={`mainNavigationLink-${link.title.replace(/\s+/g, "")}`}
                                            key={index}
                                        >
                                            <MainNavigationItem
                                                id={id}
                                                index={index}
                                                link={link}
                                                styles={styles}
                                                container={this.container}
                                                isOpen={index === selectedLinkIndex}
                                                displayChangeCustomerLink={this.props.displayChangeCustomerLink}
                                               // hover={true}
                                            />
                                        </StyledWrapper>
                                    );
                                })}
                                {showQuickOrderLink && quickOrderLink && (
                                    <StyledWrapper className="item-wrapper" {...styles.itemWrapper}>
                                        <StyledWrapper
                                            className="quick-order-item-wrapper"
                                            {...styles.quickOrderItemWrapper}
                                        >
                                            <Link
                                                className="quick-order-link"
                                                typographyProps={styles.menuItemTypography}
                                                color={styles.menuItemTypography?.color}
                                                {...styles.menuItem}
                                                id="quickOrder"
                                                href={quickOrderLink.url}
                                            >
                                                {quickOrderLink.title}
                                            </Link>
                                        </StyledWrapper>
                                    </StyledWrapper>
                                )}
                            </StyledWrapper>
                        )}
                        {displayVmiNavigation && (
                            <StyledWrapper className="container" {...styles.container} ref={this.container}>
                                <StyledWrapper className="item-wrapper" {...styles.itemWrapper} data-test-selector="vmiPageLinks">
                                    {vmiPageLinks.map(
                                        link =>
                                            link && (
                                                <Link
                                                    className="vmi-page-link"
                                                    key={link.id}
                                                    typographyProps={styles.menuItemTypography}
                                                    color={styles.menuItemTypography?.color}
                                                    {...styles.menuItem}
                                                    id={link.id}
                                                    href={link.url}
                                                    data-test-selector={`vmiPageLink-${link.title.replace(/\s+/g, "")}`}
                                                >
                                                    {link.title}
                                                </Link>
                                            ),
                                    )}
                                </StyledWrapper>
                            </StyledWrapper>
                        )}
                    </Hidden>
                </StyledWrapper>
                <Modal
                    className="mobile-search-modal"
                    {...styles.mobileSearchModal}
                    isOpen={this.state.mobileSearchModalIsOpen}
                    closeOnEsc={true}
                    handleClose={this.mobileSearchModalCloseHandler}
                    headline={
                        <SearchInput
                            id={id}
                            inputRef={this.mobileSearchInput}
                           // autocompletePositionFunction={this.getMobileSearchAutocompletePosition}
                            onBeforeGoToUrl={this.mobileSearchModalCloseHandler}
                            extendedStyles={styles.mobileSearchInputStyles}
                        />
                    }
                />
            </StyledWrapper>
        );
    }
}

MainNavigation.contextType = StylesContext;

const basicTab = {
    displayName: "Basic",
    sortOrder: 0,
};

const advancedTab = {
    displayName: "Advanced",
    sortOrder: 1,
};

const mainNavigation: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(MainNavigation),
    definition: {
        group: "Header",
        icon: "magnifying-glass",
        allowedContexts: ["Header"],
        fieldDefinitions: [
            {
                name: fields.links,
                editorTemplate: "ListField",
                onEditRow: (index: number, dispatch) => {
                    dispatch({
                        type: "SendToSite/OpenMainNavigation",
                        index,
                    });
                },
                onDoneEditingRow: dispatch => {
                    dispatch({
                        type: "SendToSite/CloseMainNavigation",
                    });
                },
                onLoad: dispatch => {
                    dispatch({
                        type: "SendToSite/CloseMainNavigation",
                    });
                },
                getDisplay: (item: HasFields, state) => {
                    const { type: typeValue, value: destinationValue } = item.fields.destination;
                    const { overrideTitle, title, linkType, parentTitle, titleLink } = item.fields;
                    let value = destinationValue;
                    let type = typeValue;
                    if (linkType === "CustomLinkList") {
                        if (parentTitle) {
                            return parentTitle;
                        }
                        type = titleLink.type;
                        value = titleLink.value;
                    }
                    if (type === "Page") {
                        const link = getPageLinkByNodeId(state, value);
                        return overrideTitle || link?.title;
                    }
                    if (type === "Category") {
                        if (overrideTitle) {
                            return overrideTitle;
                        }
                        if (value === emptyGuid) {
                            return "Products";
                        }
                        const categoryState = getCategoryState(state, value);
                        if (!categoryState.value) {
                            if (!categoryState.isLoading && value) {
                                return dispatch => {
                                    dispatch(
                                        loadCategory({
                                            id: value,
                                        }),
                                    );
                                };
                            }
                            return "";
                        }
                        return categoryState.value.shortDescription;
                    }
                    if (type === "Url") {
                        return title ?? value;
                    }
                    return value;
                },
                defaultValue: [],
                fieldType: "Translatable",
                fieldDefinitions: [
                    // {
                    //     name: "CustomMenu",
                    //     editorTemplate: "CheckboxField",
                    //     defaultValue: false,
                    // },
                    {
                        name: "disableNavigation",
                        displayName: "Disable navigation",
                        tooltip:
                            "When enabled, clicking this item will not navigate to its destination. Mega Menu / Cascading Menu behavior remains.",
                        editorTemplate: "CheckboxField",
                        defaultValue: false,
                    },
                    {
                        name: "linkType",
                        editorTemplate: "RadioButtonsField",
                        defaultValue: "Link",
                        isRequired: true,
                        // isVisible: (item: HasFields) => !item.fields.CustomMenu,
                        options: [
                            {
                                displayName: "Link",
                                value: "Link",
                            },
                            {
                                displayName: "Mega Menu",
                                value: "MegaMenu",
                            },
                            {
                                displayName: "Cascading Menu",
                                value: "CascadingMenu",
                            },
                            {
                                displayName: "Custom Link List",
                                value: "CustomLinkList",
                            },
                        ],
                    },
                    {
                        name: "overrideTitle",
                        editorTemplate: "TextField",
                        defaultValue: "",
                        isVisible: item =>
                            item.fields.destination.type !== "Url" && item.fields.linkType !== "CustomLinkList",
                    },
                    {
                        name: "destination",
                        editorTemplate: "LinkField",
                        defaultValue: {
                            value: "",
                            type: "Page",
                        },
                        isRequired: true,
                        allowUrls: item => item.fields.linkType === "Link",
                        showCategoryRoot: item => true,
                        // isVisible: (item: HasFields) => !item.fields.CustomMenu,
                    },
                    // {
                    //     name: "menuTitleisHighlighted",
                    //     displayName: "isHighlighted",
                    //     editorTemplate: "CheckboxField",
                    //     defaultValue: false,
                    // },
                    {
                        name: "dropDownValue",
                        displayName: "Select Type",
                        editorTemplate: "DropDownField",
                        options: [
                            {
                                displayName: "None",
                                value: "none",
                            },
                            {
                                displayName: "Top Seller",
                                value: "topSeller",
                            },
                            {
                                displayName: "New",
                                value: "new",
                            },
                            {
                                displayName: "Clearance",
                                value: "clearance",
                            },
                            {
                                displayName: "Make It Yours",
                                value: "makeItYours",
                            },
                        ],
                        defaultValue: "none",
                    },
                    {
                        name: "overrideTitle",
                        editorTemplate: "TextField",
                        defaultValue: "",
                        isVisible: item => item.fields.destination.type !== "Url",
                    },
                    {
                        name: "title",
                        editorTemplate: "TextField",
                        defaultValue: "",
                        isRequired: true,
                        isVisible: item => item.fields.destination.type === "Url",
                    },
                    // {
                    //     name: "numberOfColumns",
                    //     editorTemplate: "DropDownField",
                    //     defaultValue: 6,
                    //     options: [{ value: 2 }, { value: 3 }, { value: 4 }, { value: 6 }],
                    //     isRequired: true,
                    //     isVisible: (item: HasFields) => item.fields.linkType === "MegaMenu",
                    // },
                    {
                        name: "maxDepth",
                        editorTemplate: "DropDownField",
                        defaultValue: 3,
                        options: [{ value: 1 }, { value: 2 }, { value: 3 }, { value: 4 }],
                        isRequired: true,
                        // isVisible: (item: HasFields) =>
                        //     item.fields.linkType === "CascadingMenu" && !item.fields.CustomMenu,
                    },
                    {
                        name: "openInNewWindow",
                        editorTemplate: "CheckboxField",
                        defaultValue: false,
                        isVisible: (item: HasFields) => item.fields.linkType === "Link",
                    },
                    {
                        name: "isCustomMenu",
                        editorTemplate: "CheckboxField",
                        defaultValue: false,
                        isVisible: (item: HasFields) => item.fields.linkType === "MegaMenu",
                    },
                    {
                        name: "customMenuTitle",
                        displayName: "Image Section Title",
                        editorTemplate: "TextField",
                        defaultValue: "",
                        isVisible: (item: HasFields) => item.fields.isCustomMenu === true,
                    },
                    // {
                    //     name: "customMenuTitleLink",
                    //     editorTemplate: "LinkField",
                    //     defaultValue: {
                    //         value: "",
                    //         type: "Page",
                    //     },
                    //     isRequired: true,
                    //     allowUrls: item => item.fields.linkType === "Link",
                    //     showCategoryRoot: item => true,
                    //     isVisible: (item: HasFields) => item.fields.isCustomMenu === true,
                    // },
                    // {
                    //     name: "customMenuImage",
                    //     displayName: " Title Image",
                    //     editorTemplate: "ImagePickerField",
                    //     defaultValue: "",
                    //     // tab: basicTab,
                    //     isVisible: (item: HasFields) => item.fields.isCustomMenu === true,
                    // },
                    {
                        name: "customMenuImageTittle",
                        editorTemplate: "ListField",
                        getDisplay: (mLink: HasFields) => {
                            return mLink.fields.customMenuImageTittle;
                        },
                        isVisible: (item: HasFields) => item.fields.isCustomMenu === true,
                        defaultValue: [],
                        fieldDefinitions: [
                            {
                                name: "internalImgTitle",
                                displayName: "internalImgTitle",
                                editorTemplate: "TextField",
                                defaultValue: "",
                            },
                            {
                                name: "internalImgURL",
                                displayName: "Image",
                                editorTemplate: "ImagePickerField",
                                defaultValue: "",
                            },
                            {
                                name: "internalImgTitledestination",
                                editorTemplate: "TextField",
                                defaultValue: "",

                                // defaultValue: {
                                //     value: "",
                                //     type: "Page",
                                // },
                                // isRequired: true,
                                // allowUrls: () => true,
                                // showCategoryRoot: item => true,
                            },
                        ],
                    },
                    // {
                    //     name: "customMenuImageTittle",
                    //     displayName: "custom Menu Image Tittle",
                    //     editorTemplate: "TextField",
                    //     defaultValue: "",
                    //     // tab: basicTab,
                    //     isVisible: (item: HasFields) => item.fields.isCustomMenu === true,
                    // },
                    {
                        name: "subMenuLinks",
                        editorTemplate: "ListField",
                        getDisplay: (mLink: HasFields) => {
                            return mLink.fields.subMenuTitle;
                        },
                        defaultValue: [],
                        fieldDefinitions: [
                            {
                                name: "subMenuTitle",
                                displayName: "subMenuTitle",
                                editorTemplate: "TextField",
                                defaultValue: "",
                            },
                            {
                                name: "subDestination",
                                editorTemplate: "LinkField",
                                defaultValue: {
                                    value: "",
                                    type: "Url",
                                },
                                // isRequired: true,
                                showCategoryRoot: item => true,
                            },
                            {
                                name: "InternalMenuLinks",
                                editorTemplate: "ListField",
                                getDisplay: (mLink: HasFields) => {
                                    return mLink.fields.internalMenuTitle;
                                },
                                defaultValue: [],
                                fieldDefinitions: [
                                    {
                                        name: "internalMenuTitle",
                                        displayName: "internalMenuTitle",
                                        editorTemplate: "TextField",
                                        defaultValue: "",
                                    },
                                    {
                                        name: "internalMenuTitleisBold",
                                        displayName: "isBold",
                                        editorTemplate: "CheckboxField",
                                        defaultValue: false,
                                    },
                                    // {
                                    //     name: "internalMenuTitleisHighlighted",
                                    //     displayName: "isHighlighted",
                                    //     editorTemplate: "CheckboxField",
                                    //     defaultValue: false,
                                    // },
                                    {
                                        name: "internaldropDownValue",
                                        displayName: "Select Type",
                                        editorTemplate: "DropDownField",
                                        options: [
                                            {
                                                displayName: "None",
                                                value: "none",
                                            },
                                            {
                                                displayName: "Top Seller",
                                                value: "topSeller",
                                            },
                                            {
                                                displayName: "New",
                                                value: "new",
                                            },
                                            {
                                                displayName: "Clearance",
                                                value: "clearance",
                                            },
                                            {
                                                displayName: "Make It Yours",
                                                value: "makeItYours",
                                            },
                                            {
                                                displayName: "Section Heading",
                                                value: "sectionHeading",
                                            },
                                        ],
                                        defaultValue: "none",
                                    },
                                    {
                                        name: "destination",
                                        editorTemplate: "LinkField",
                                        defaultValue: {
                                            value: "",
                                            type: "Page",
                                        },
                                        isRequired: true,
                                        showCategoryRoot: item => true,
                                    },
                                ],
                            },
                        ],
                        tab: basicTab,
                        isVisible: (item: HasFields) => item.fields.isCustomMenu === true,
                    },
                ],
                tab: basicTab,
            },
            {
                name: fields.showQuickOrder,
                editorTemplate: "CheckboxField",
                defaultValue: true,
                fieldType: "General",
                tab: basicTab,
            },
            {
                name: fields.openParentPages,
                displayName: "Open Parent Pages",
                tooltip: "When enabled, tapping on a text link in the flyout menu will directly open the linked webpage and require users to click the chevron to access child pages. If disabled, tapping any link in the flyout menu will navigate to a submenu of child pages.",
                editorTemplate: "CheckboxField",
                defaultValue: false,
                fieldType: "General",
                tab: basicTab,
            },
            {
                name: fields.customCSS,
                displayName: "Custom CSS",
                editorTemplate: "CodeField",
                fieldType: "General",
                tab: advancedTab,
                defaultValue: defaultCustomCss,
                isVisible: (item, shouldDisplayAdvancedFeatures) => !!shouldDisplayAdvancedFeatures,
                validate: value => {
                    if (value === undefined || value === null) {
                        return "";
                    }

                    const result = cssLinter.parse(value, { silent: true });
                    if (result?.stylesheet?.parsingErrors) {
                        // the error output at this time only has room for one line so we just show the first error
                        return result.stylesheet.parsingErrors.length <= 0
                            ? ""
                            : result.stylesheet.parsingErrors.map(error => `${error.reason} on line ${error.line}`)[0];
                    }

                    return "Unable to parse Css";
                },
                options: {
                    mode: "css",
                    lint: true,
                    autoRefresh: true,
                },
            },
        ],
    },
};

export default mainNavigation;